import * as TYPES from './action-types.js';
export default {
	namespaced: true,
	state: {
		areaId: undefined, // 区域ID
		areaPickerVisible: false, // 区域选择器是否弹出
	},
	getters: {
		areaId: state => state.areaId,
		areaPickerVisible: state => state.areaPickerVisible
	},
	mutations: {
		[TYPES.HOME__SET_AREA_ID](state, payload){
			state.areaId = payload;
		},
		[TYPES.HOME__SET_AREA_PICKER_VISIBLE](state, payload) {
			state.areaPickerVisible = payload;
		}
	},
	actions: {
		[TYPES.HOME__SET_AREA_ID]({commit}, payload) {
			commit(TYPES.HOME__SET_AREA_ID, payload);
		},
		[TYPES.HOME__SET_AREA_PICKER_VISIBLE]({commit}, payload) {
			commit(TYPES.HOME__SET_AREA_PICKER_VISIBLE, payload);
		}
	}
};
